import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./BottomNav.module.css";

function BottomNav(props) {
  return (
    <section className={styles.lowerNavBar}>
      <div className={styles.lowerNavBar_inner}>
        <div>
          <NavLink
            to="/home"
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.1667 14.6662H3.83333C3.65652 14.6662 3.48695 14.596 3.36193 14.471C3.2369 14.346 3.16667 14.1764 3.16667 13.9996V8.66625H1.83333L8.028 2.47092C8.08992 2.40893 8.16344 2.35976 8.24437 2.32621C8.32531 2.29266 8.41206 2.27539 8.49967 2.27539C8.58728 2.27539 8.67403 2.29266 8.75496 2.32621C8.83589 2.35976 8.90942 2.40893 8.97133 2.47092L15.1667 8.66625H13.8333V13.9996C13.8333 14.1764 13.7631 14.346 13.6381 14.471C13.513 14.596 13.3435 14.6662 13.1667 14.6662ZM7.16667 9.99958H9.83333V13.3329H12.5V7.88492L8.5 3.88492L4.5 7.88492V13.3329H7.16667V9.99958Z"
              />
            </svg>
            <p>Home</p>
          </NavLink>
        </div>

        <div>
          <NavLink
            to="/health"
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.3333 2H2.33333C1.6 2 1 2.6 1 3.33333V11.3333C1 12.0667 1.6 12.6667 2.33333 12.6667H5.66667V14H11V12.6667H14.3333C15.0667 12.6667 15.66 12.0667 15.66 11.3333L15.6667 3.33333C15.6667 2.6 15.0667 2 14.3333 2ZM14.3333 11.3333H2.33333V3.33333H14.3333V11.3333ZM3 9.33333V10.6667H4.33333C4.33333 9.92667 3.74 9.33333 3 9.33333ZM3 7.33333V8.28667C4.31333 8.28667 5.38 9.35333 5.38 10.6667H6.33333C6.33333 8.82667 4.84 7.33333 3 7.33333ZM3 5.33333V6.3C5.40667 6.3 7.36667 8.25333 7.36667 10.6667H8.33333C8.33333 7.72 5.94 5.33333 3 5.33333Z"
                fill="#BABABA"
              />
            </svg>

            <p>MotorAi</p>
          </NavLink>
        </div>

        <div>
          <NavLink
            to="/insurance"
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.61333 4.99984L10.6667 7.33317H5.33333L6.28 4.99984H9.61333ZM6 7.99984C5.63333 7.99984 5.33333 8.29984 5.33333 8.6665C5.33333 9.03317 5.63333 9.33317 6 9.33317C6.36667 9.33317 6.66667 9.03317 6.66667 8.6665C6.66667 8.29984 6.36667 7.99984 6 7.99984ZM10 7.99984C9.63333 7.99984 9.33333 8.29984 9.33333 8.6665C9.33333 9.03317 9.63333 9.33317 10 9.33317C10.3667 9.33317 10.6667 9.03317 10.6667 8.6665C10.6667 8.29984 10.3667 7.99984 10 7.99984ZM14 3.33317V7.33317C14 11.0332 11.44 14.4932 8 15.3332C4.56 14.4932 2 11.0332 2 7.33317V3.33317L8 0.666504L14 3.33317ZM12 7.99984L10.56 4.6665C10.4267 4.27984 10.0533 3.99984 9.61333 3.99984H6.28C5.84 3.99984 5.46667 4.27984 5.33333 4.6665L4 7.99984V10.6665C4 11.0332 4.3 11.3332 4.66667 11.3332H5.33333C5.7 11.3332 6 11.0332 6 10.6665V9.99984H10V10.6665C10 11.0332 10.3 11.3332 10.6667 11.3332H11.3333C11.7 11.3332 12 11.0332 12 10.6665V7.99984Z"
                fill="#BABABA"
              />
            </svg>

            <p>Insurance</p>
          </NavLink>
        </div>

        <div onClick={props.onClick}>
          <NavLink
            to="/track"
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
          >
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.66667 14.6654C7.74444 14.6654 6.87778 14.4903 6.06667 14.14C5.25556 13.7903 4.55 13.3154 3.95 12.7154C3.35 12.1154 2.87511 11.4098 2.52533 10.5987C2.17511 9.78759 2 8.92092 2 7.9987C2 7.07648 2.17511 6.20981 2.52533 5.3987C2.87511 4.58759 3.35 3.88203 3.95 3.28203C4.55 2.68203 5.25556 2.20692 6.06667 1.8567C6.87778 1.50692 7.74444 1.33203 8.66667 1.33203H8.83333C8.97778 1.33203 9.09733 1.37914 9.192 1.47336C9.28622 1.56803 9.33333 1.68759 9.33333 1.83203V6.8487C9.53333 6.97092 9.69444 7.12914 9.81667 7.32337C9.93889 7.51803 10 7.74314 10 7.9987C10 8.36536 9.86956 8.67914 9.60867 8.94003C9.34733 9.20136 9.03333 9.33203 8.66667 9.33203C8.3 9.33203 7.98622 9.20136 7.72533 8.94003C7.464 8.67914 7.33333 8.36536 7.33333 7.9987C7.33333 7.74314 7.39444 7.51536 7.51667 7.31536C7.63889 7.11536 7.8 6.95981 8 6.8487V5.41536C7.42222 5.57092 6.94444 5.8847 6.56667 6.3567C6.18889 6.82914 6 7.37648 6 7.9987C6 8.73203 6.26111 9.35981 6.78333 9.88203C7.30556 10.4043 7.93333 10.6654 8.66667 10.6654C9.4 10.6654 10.0278 10.4043 10.55 9.88203C11.0722 9.35981 11.3333 8.73203 11.3333 7.9987C11.3333 7.74314 11.2973 7.49025 11.2253 7.24003C11.1529 6.99025 11.0444 6.75425 10.9 6.53203C10.8 6.37648 10.7584 6.22359 10.7753 6.07337C10.7918 5.92359 10.8556 5.79314 10.9667 5.68203C11.1 5.5487 11.2693 5.48203 11.4747 5.48203C11.6804 5.48203 11.8444 5.57092 11.9667 5.7487C12.2111 6.10425 12.3889 6.47359 12.5 6.8567C12.6111 7.24025 12.6667 7.62092 12.6667 7.9987C12.6667 9.10981 12.2778 10.0543 11.5 10.832C10.7222 11.6098 9.77778 11.9987 8.66667 11.9987C7.55556 11.9987 6.61111 11.6098 5.83333 10.832C5.05556 10.0543 4.66667 9.10981 4.66667 7.9987C4.66667 6.9987 4.98333 6.12937 5.61667 5.3907C6.25 4.65159 7.04444 4.20425 8 4.0487V2.6987C6.67778 2.86536 5.56956 3.4487 4.67533 4.4487C3.78067 5.4487 3.33333 6.63203 3.33333 7.9987C3.33333 9.48759 3.85 10.7487 4.88333 11.782C5.91667 12.8154 7.17778 13.332 8.66667 13.332C10.1556 13.332 11.4167 12.8154 12.45 11.782C13.4833 10.7487 14 9.48759 14 7.9987C14 7.34314 13.9056 6.75425 13.7167 6.23203C13.5278 5.70981 13.2611 5.22648 12.9167 4.78203C12.7944 4.62648 12.7362 4.45981 12.742 4.28203C12.7473 4.10425 12.8167 3.9487 12.95 3.81536C13.0833 3.68203 13.2418 3.61536 13.4253 3.61536C13.6084 3.61536 13.7556 3.68759 13.8667 3.83203C14.3333 4.3987 14.6944 5.02648 14.95 5.71536C15.2056 6.40425 15.3333 7.16536 15.3333 7.9987C15.3333 8.92092 15.1582 9.78759 14.808 10.5987C14.4582 11.4098 13.9833 12.1154 13.3833 12.7154C12.7833 13.3154 12.0778 13.7903 11.2667 14.14C10.4556 14.4903 9.58889 14.6654 8.66667 14.6654Z"
                fill="#BABABA"
              />
            </svg>

            <p>Track</p>
          </NavLink>
        </div>

        <div>
          <NavLink
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
            to="/spare-parts"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.773 3.48534L13.993 3.30134L11.885 5.39734L10.691 4.18134L12.747 2.02434L12.567 1.23234C12.1326 1.08699 11.6781 1.01007 11.22 1.00434C10.7203 0.996652 10.2243 1.09196 9.76303 1.28434C9.31763 1.48595 8.91503 1.7711 8.57703 2.12434C8.20078 2.48075 7.9028 2.91154 7.70203 3.38934C7.31548 4.34022 7.31548 5.40445 7.70203 6.35534C5.61727 8.40633 3.55942 10.4845 1.52903 12.5893C1.31903 12.8643 1.21903 13.2073 1.24503 13.5523C1.26552 13.9234 1.43239 14.2712 1.70903 14.5193C1.83303 14.6543 1.98103 14.7663 2.14603 14.8473C2.31603 14.9223 2.49903 14.9653 2.68403 14.9743C3.00003 14.9683 3.30303 14.8483 3.53803 14.6373C5.08603 13.1803 8.05203 10.1873 9.73703 8.43334C10.194 8.62734 10.685 8.72734 11.181 8.72634C11.6803 8.72594 12.1744 8.62548 12.6342 8.43088C13.094 8.23628 13.5102 7.95149 13.858 7.59334C14.5726 6.8646 14.9717 5.88394 14.969 4.86334C14.9806 4.39631 14.9143 3.93062 14.773 3.48534V3.48534ZM2.93303 13.9283C2.89454 13.9625 2.84814 13.9866 2.79803 13.9983C2.74873 14.0069 2.69833 14.0069 2.64903 13.9983C2.59734 13.9905 2.5481 13.971 2.50503 13.9413C2.4588 13.9143 2.41972 13.8766 2.39103 13.8313C2.25103 13.6883 2.12003 13.4163 2.25103 13.2633C3.62103 11.8063 6.44203 8.95834 8.20603 7.21734C8.30603 7.34934 8.41603 7.47534 8.53403 7.59334C8.65203 7.71634 8.77903 7.83034 8.91403 7.93434C7.20803 9.68434 4.42603 12.4983 2.93403 13.9283H2.93303ZM14.051 4.86334C14.053 5.62834 13.755 6.36334 13.219 6.91134C12.6842 7.43603 11.9648 7.72996 11.2155 7.72996C10.4663 7.72996 9.7469 7.43603 9.21203 6.91134C8.82001 6.50223 8.55222 5.99023 8.43981 5.43488C8.32739 4.87954 8.37498 4.30369 8.57703 3.77434C8.71152 3.41407 8.92013 3.08604 9.18937 2.81147C9.4586 2.53689 9.78247 2.32188 10.14 2.18034C10.4795 2.03824 10.844 1.96548 11.212 1.96634H11.466L9.64903 3.83934V4.53534L11.544 6.42134H12.204L14.051 4.60534V4.86334V4.86334ZM3.24003 6.68834H4.77103L5.47603 7.40534L6.15403 6.73134L5.48903 6.05334V6.01034L5.54603 4.36134L5.32603 3.92434L2.46603 2.04234L1.87503 2.10834L1.04403 2.95734L0.978027 3.55634L2.81603 6.47434L3.24003 6.68934V6.68834ZM2.29503 3.05634L4.60903 4.58034L4.57003 5.70334H3.49403L2.00203 3.34134L2.29503 3.05634V3.05634ZM9.40003 10.0163L10.074 9.34334L13.18 12.5283C13.4416 12.8033 13.5876 13.1683 13.5876 13.5478C13.5876 13.9274 13.4416 14.2924 13.18 14.5673C12.9833 14.7693 12.7303 14.9074 12.4541 14.9635C12.1778 15.0197 11.891 14.9914 11.631 14.8823C11.4651 14.8087 11.3163 14.7015 11.194 14.5673L8.05203 11.3643L8.73103 10.6863L11.863 13.8803C11.9051 13.9268 11.9575 13.9627 12.016 13.9853C12.1311 14.0321 12.2599 14.0321 12.375 13.9853C12.4335 13.9627 12.4859 13.9268 12.528 13.8803C12.5718 13.837 12.6059 13.7848 12.628 13.7273C12.651 13.6687 12.6632 13.6063 12.664 13.5433C12.663 13.4804 12.6512 13.4182 12.629 13.3593C12.6069 13.3018 12.5728 13.2497 12.529 13.2063L9.40003 10.0163Z"
                fill="#BABABA"
              />
            </svg>

            <p>Services</p>
          </NavLink>
        </div>

        {/* <div>
          <NavLink
            to="/papers"
            className={(navData) =>
              navData.isActive ? `${styles.active}` : ""
            }
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_174_628)">
                <path d="M6.66663 3.55566H10.6666V4.44455H6.66663V3.55566Z" />
                <path d="M6.66663 5.3335H10.6666V6.22238H6.66663V5.3335Z" />
                <path d="M6.66663 7.11133H10.6666V8.00022H6.66663V7.11133Z" />
                <path d="M6.66663 8.88867H10.6666V9.77756H6.66663V8.88867Z" />
                <path d="M6.66663 10.6665H10.6666V11.5554H6.66663V10.6665Z" />
                <path d="M4.88892 3.55566H5.7778V4.44455H4.88892V3.55566Z" />
                <path d="M4.88892 5.3335H5.7778V6.22238H4.88892V5.3335Z" />
                <path d="M4.88892 7.11133H5.7778V8.00022H4.88892V7.11133Z" />
                <path d="M4.88892 8.88867H5.7778V9.77756H4.88892V8.88867Z" />
                <path d="M4.88892 10.6665H5.7778V11.5554H4.88892V10.6665Z" />
                <path d="M12.4444 0.888672H3.55551C3.31977 0.888672 3.09367 0.982322 2.92698 1.14902C2.76028 1.31572 2.66663 1.54181 2.66663 1.77756V14.222C2.66663 14.4578 2.76028 14.6838 2.92698 14.8505C3.09367 15.0172 3.31977 15.1109 3.55551 15.1109H12.4444C12.6802 15.1109 12.9062 15.0172 13.0729 14.8505C13.2396 14.6838 13.3333 14.4578 13.3333 14.222V1.77756C13.3333 1.54181 13.2396 1.31572 13.0729 1.14902C12.9062 0.982322 12.6802 0.888672 12.4444 0.888672ZM12.4444 14.222H3.55551V1.77756H12.4444V14.222Z" />
              </g>
              <defs>
                <clipPath id="clip0_174_628">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>Papers</p>
          </NavLink>
        </div> */}
      </div>
    </section>
  );
}

export default BottomNav;
